import { GraphQLResult } from '@aws-amplify/api/lib/types';

export const enum LoadingState {
  Init = 'Init',
  Loading = 'Loading',
  Loaded = 'Loaded',
}
export interface ErrorState {
  errorMessage: string;
}

export type CallState = LoadingState | ErrorState;

// Helper function to extract error, if there is one.
export function getError(callState: CallState): string | null { 
  if ((callState as ErrorState).errorMessage !== undefined) { 
      return (callState as ErrorState).errorMessage;
  } 
  return null;
}

export function parseErrorMessage(result: GraphQLResult): string | null {
  if (!result.errors || result.errors === null) { return ''; }
  const errorMessages =
    result.errors.map((err: any) => `${err.path ? '[' + err.path.join(' ') + '] ' : ''} ${err.message}` );
  return errorMessages.join('.');
}
